export default __webpack_public_path__ + "static/media/IMG_9890.edb50a79.jpg";